import { render, staticRenderFns } from "./mCooperation.vue?vue&type=template&id=27964c7d&scoped=true&"
import script from "./mCooperation.vue?vue&type=script&lang=js&"
export * from "./mCooperation.vue?vue&type=script&lang=js&"
import style0 from "./mCooperation.vue?vue&type=style&index=0&id=27964c7d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27964c7d",
  null
  
)

export default component.exports